import { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import api, { track } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { Spinner } from "@/components/shared";

export default function MsAuthCallback() {
  const navigate = useNavigate();
  const { refresh } = useAuth();
  const processed = useRef(false);
  const [error, setError] = useState("");

  useEffect(() => {
    if (processed.current) return;
    processed.current = true;
    (async () => {
      try {
        const { getMsal } = await import("@/lib/msal");
        const msal = await getMsal();
        const result = await msal.handleRedirectPromise({ navigateToLoginRequestUrl: false });
        if (!result?.idToken) {
          setError("Microsoft did not return a sign-in result. Please try again.");
          return;
        }
        const res = await api.post("/auth/microsoft", { id_token: result.idToken });
        if (res.data?.is_new_user) track("signup_completed", { method: "microsoft" });
        else track("login_completed", { method: "microsoft" });
        window.history.replaceState(null, "", window.location.pathname);
        await refresh();
        navigate("/app/dashboard");
      } catch (e) {
        console.error("Microsoft sign-in failed", e);
        setError(e?.response?.data?.detail || e?.errorMessage || e?.message || "Microsoft sign-in failed.");
      }
    })();
  }, [navigate, refresh]);

  if (error) {
    return (
      <div className="flex min-h-screen flex-col items-center justify-center gap-4 bg-background px-6" data-testid="ms-auth-error">
        <p className="max-w-md text-center text-sm text-red-700">{error}</p>
        <button onClick={() => navigate("/login")} className="text-sm font-medium text-navy underline">
          Back to sign in
        </button>
      </div>
    );
  }
  return (
    <div className="flex min-h-screen items-center justify-center bg-background" data-testid="ms-auth-loading">
      <Spinner />
    </div>
  );
}
